import React from 'react';
import ComissaoService from '../../../../lib/api/comissao/comissao';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroComissao extends React.Component<{}, {}> {
	constructor(props: any) {
		super(props);
		this.state = {};
	}

	baixarExcelParametrosComissao() {
		return ComissaoService.obterExcel();
	}

	enviarParametrosEventGrid() {
		return ComissaoService.enviarParametrosAoEventGrid();
	}

	render() {
		return (
			<TemplateParametro
				enviarParametrosEventGrid={this.enviarParametrosEventGrid}
				baixarExcelParametros={this.baixarExcelParametrosComissao}
				enviarExcelParametros={ComissaoService.comissaoExcelPost}
				deletarExcelParametros={ComissaoService.deletarExcelParametros}
				nomeDoArquivo='Parametro Comissao'
			/>
		);
	}
}

export default ParametroComissao;
